import { requestService } from '@/services/request-form.service';
import { useMutation } from '@tanstack/react-query';
import { RequestForm } from '@/types/request';

export const useMutationSubmitRequest = () => {
  return useMutation((requestFormParams: RequestForm) => {
    return requestService.submitRequestForm(requestFormParams);
  });
};
